import React, { useRef, useState, useEffect } from "react";
import api from "../api";
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";

export default function PrivacyPolicy() {
    const { id } = useParams();

    const tel = id || "87475315558";

    const [phone, setPhone] = useState("");
    const [mail, setMail] = useState("");

    useEffect(() => {
        const formData = new FormData();
        formData.append("phone", tel);

        api.post("/getFranchiseeByPhone", formData, {
            headers: { "Content-Type": "application/json" },
        })
            .then(({ data }) => {
                setPhone(
                    `+7 ${data.phone.substring(1, 4)} ${data.phone.substring(
                        4,
                        7
                    )} ${data.phone.substring(7, 9)} ${data.phone.substring(9)}`
                );
                setMail(data.mail);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [tel]);

    const footerRef = useRef(null);

    const privacyPolicy = `ТОО «Partner’s Mountain Water Co» (Приложение «Аквамаркет Тибетская»)
(Действует на территории Республики Казахстан)
Настоящая Политика конфиденциальности (далее – «Политика») определяет порядок сбора, обработки, хранения и защиты персональных данных (далее – «ПД») Пользователей, которые использует Приложение «Аквамаркет Тибетская» (далее – «Приложение»).

1. Общие положения
1.1. Оператор (Владелец) ПД: ТОО «Partner’s Mountain Water Co», БИН: 090840006340, Юридический адрес: г. Алматы, ул. Шевченко, 7, оф. 59А (далее – «Оператор» или «Мы»).
1.2. Цель данной Политики – обеспечение надлежащей защиты ПД от несанкционированного доступа, неправомерной обработки и распространения.
1.3. Политика является неотъемлемой частью Публичной оферты и распространяется на всех Пользователей Приложения.
1.4. Акцепт Политики. Регистрация в Приложении, авторизация, оформление Заказа или любое иное использование Приложения означает полное и безоговорочное согласие Пользователя с условиями настоящей Политики (согласно пункту 2 статьи 8 Закона РК «О персональных данных и их защите»).

2. Перечень собираемых и обрабатываемых персональных данных
Оператор обрабатывает следующие категории ПД, необходимые для заключения и исполнения договора купли-продажи Товара (Заказа):
Категория данных
Цель обработки
Идентификационные данные


ФИО / Наименование организации
Для идентификации Пользователя при оформлении Заказа и доставке.
Контактные данные


Номер телефона
Для связи, подтверждения Заказа, уведомлений о доставке.
Адрес электронной почты (E-mail)
Для отправки электронных чеков, уведомлений, рекламных рассылок.
  Данные Заказа и Доставки


Адрес доставки
Для осуществления доставки Товара.
История Заказов
Для контроля исполнения обязательств и статистики.
Технические и сервисные данные


IP-адрес, данные об устройстве, время доступа
Для обеспечения работоспособности Приложения, безопасности и аналитики.
Сведения о платежах (без данных карты)
Для учета оплат и пополнения Внутреннего баланса.


3. Цели сбора и обработки персональных данных
Обработка ПД Пользователя осуществляется в следующих целях:
3.1. Исполнение договора (Заказа): Продажа, оплата, доставка Товара, включая связь с Пользователем по вопросам Заказа.
3.2. Техническое функционирование: Обеспечение работы и безопасности Приложения, устранение ошибок.
3.3. Внутренний учет и отчетность: Ведение бухгалтерского и налогового учета, статистический анализ.
3.4. Маркетинг (при наличии согласия): Отправка рекламных и информационных рассылок о новых продуктах, акциях и специальных предложениях.
3.5. Исполнение требований законодательства РК, включая требования налоговых органов и правоохранительных органов.

4. Условия и порядок обработки персональных данных
4.1. Обработка ПД осуществляется Оператором с использованием баз данных, находящихся на территории Республики Казахстан, или в соответствии с требованиями законодательства РК о трансграничной передаче данных.
4.2. Обработка включает сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение ПД.
4.3. Срок обработки: ПД обрабатываются до момента достижения целей обработки, отзыва согласия Пользователем или удаления Профиля, за исключением данных, которые по закону (например, налоговое законодательство) должны храниться более длительный срок.

5. Передача персональных данных третьим лицам
Оператор вправе передавать ПД Пользователя следующим категориям третьих лиц:
5.1. Платежный оператор: ТОО «Verto Business» и/или иные партнеры, обеспечивающие проведение финансовых транзакций (передаются только данные, необходимые для идентификации платежа).
5.2. Служба доставки:Сотрудники или подрядчики, осуществляющие доставку Товара (передаются ФИО, номер телефона и адрес доставки).
5.3. Государственные органы: По требованию законодательства РК (налоговые органы, правоохранительные органы, суды).
5.4. Партнеры по аналитике и рекламе: Для проведения статистических и маркетинговых исследований (передача осуществляется в обезличенном или агрегированном виде).

6. Права Пользователя как Субъекта персональных данных
В соответствии с Законом РК «О персональных данных и их защите», Пользователь имеет право:
6.1. Знать о наличии у Оператора своих ПД.
6.2. Получать информацию о третьих лицах, которым Оператор передал ПД.
6.3. Отзывать согласие на обработку ПД (п. 4 ст. 8 Закона). Отзыв согласия может быть осуществлен путем направления письменного запроса на электронный адрес info@tibetskaya.kz или через функционал Приложения (если предусмотрен). Отзыв согласия влечет прекращение обработки ПД, что может сделать невозможным дальнейшее использование Приложения и оформление Заказов.
6.4. Требовать изменения и дополнения своих ПД.
6.5. Требовать блокирования или уничтожения ПД, если они были собраны с нарушением закона или не нужны для заявленной цели.
6.6. Обжаловать действия или бездействие Оператора.

7. Обеспечение безопасности персональных данных
7.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты ПД от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
7.2. Меры включают ограничение доступа сотрудников к ПД, использование защищенных каналов передачи данных (шифрование), регулярное обновление программного обеспечения и контроль соблюдения Политики.

8. Изменение Политики
8.1. Оператор имеет право вносить изменения в настоящую Политику в любое время.
8.2. Новая редакция Политики вступает в силу с момента ее публикации в Приложении или на сайте по адресу: www.tibetskaya.kz/PrivacyPolicy.
8.3. Продолжение использования Приложения после публикации новой редакции Политики означает согласие Пользователя с внесенными изменениями.

9. Контактная информация Оператора
ТОО «Partner’s Mountain Water Co»
БИН: 090840006340
Телефон: +7 727 3172737
E-mail для запросов: info@tibetskaya.kz
Адрес: г. Алматы, ул. Шевченко, 7, оф. 59А
`

    const formattedPolicy = privacyPolicy.split('\n').map((paragraph, index) => {
        if (paragraph.trim() === "") return null; // Пропускаем пустые строки
        return paragraph.startsWith(' ') ? <p key={index}>{paragraph.trim()}</p> : <h3 key={index}>{paragraph.trim()}</h3>;
    });

    return (
        <div className="flex flex-col min-h-screen justify-between">
            <div className="pt-5 px-5 space-y-3">
                <h2 className="text-lg font-bold">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h2>
                {formattedPolicy}
            </div>

            <div className="">
                <Footer ref={footerRef} phone={phone} mail={mail} />
            </div>
        </div>
    );
}
